import SetBlockchainAddressPasswordStep from './SetBlockchainAddressPasswordStep';

export default SetBlockchainAddressPasswordStep;
